export default __webpack_public_path__ + "static/media/close.ea305293.svg";